import { default as internal_traceUFOInteraction } from '../trace-interaction/internal/trace-ufo-interaction';
function traceUFOPress(name, timestamp) {
  return internal_traceUFOInteraction(name, 'press', timestamp);
}
export default traceUFOPress;